import axios from "axios";

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        load({ state }, data) {
            const { url, params } = data;

            if (typeof state[url] !== 'undefined') {
                return state[url];
            }

            const promise = new Promise((resolve, reject) => {
                const method = data?.method || 'get';
                axios({
                    url,
                    method,
                    headers: data?.headers,
                    data: params,
                    params: method === 'get' ? params : null,
                    signal: data?.signal,
                }).then((response) => {
                    const responseData = response.data?.data || response.data;
                    if (typeof data.cache === 'undefined' || data.cache === true) {
                        state[url] = new Promise((resolve) => resolve(data?.fullResponse ? response : responseData));
                    }
                    resolve(data?.fullResponse ? response : responseData);
                }).catch(reject);
            });

            if (typeof data.cache === 'undefined' || data.cache === true) {
                state[url] = promise;
                return state[url];
            }

            return promise;
        }
    },
}
